import type { StripePaymentMethod } from "@api/private/getStripePaymentMethods";
import AddCreditCard from "@components/creditCard/AddCreditCard";
import SavedPaymentMethodSelector from "@components/SavedPaymentMethodSelector";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import type { StripeCardElementChangeEvent } from "@stripe/stripe-js";

interface CreditCardManagementPanelProps {
  open: boolean;
  onClose: () => void;
  selectedPaymentMethod: string | null;
  handleSavedMethodChange: (paymentMethodId: string | null) => void;
  defaultPaymentMethodId: string | null;
  savedPaymentMethods: StripePaymentMethod[];
  isLoadingPaymentMethods: boolean;
  paymentMethodsError: Error | null;
  refetchPaymentMethods: () => void;
  handleCreditCardChange: (event: StripeCardElementChangeEvent) => void;
  cardError: string | null;
}

export default function CreditCardManagementPanel({
  open,
  onClose,
  selectedPaymentMethod,
  handleSavedMethodChange,
  defaultPaymentMethodId,
  savedPaymentMethods,
  isLoadingPaymentMethods,
  paymentMethodsError,
  refetchPaymentMethods,
  handleCreditCardChange,
  cardError,
}: CreditCardManagementPanelProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent dividers>
        <SavedPaymentMethodSelector
          paymentMethods={savedPaymentMethods}
          isLoading={isLoadingPaymentMethods}
          error={paymentMethodsError}
          selectedPaymentMethod={selectedPaymentMethod}
          onSelectionChange={handleSavedMethodChange}
          defaultPaymentMethodId={defaultPaymentMethodId || undefined}
          hideAddNewButton
          refetchPaymentMethods={refetchPaymentMethods}
        />
        <AddCreditCard handleCreditCardChange={handleCreditCardChange} cardError={cardError} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={async () => {
            try {
              await refetchPaymentMethods();
            } finally {
              onClose();
            }
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
